import type { AffectationHote, Foyer, RepartitionInput } from './types.js';

/** Jeu de démo du prototype Python : 20 personnes, 14 foyers, 4 hôtes par étape. */
const brut: Array<[string, string, string[], string, string[]]> = [
  // [id, nom, membres, adresse, disponibilités]
  ['martin', 'les Martin', ['Claire Martin', 'Julien Martin'], '14 rue Notre-Dame', ['entree', 'plat']],
  ['benali', 'les Benali', ['Samira Benali', 'Karim Benali'], '3 rue Borie', ['plat']],
  ['lefevre', 'les Lefèvre', ['Anne Lefèvre', 'Paul Lefèvre'], '27 rue Saint-Joseph', ['dessert']],
  ['nguyenroux', 'les Nguyen-Roux', ['Linh Nguyen', 'Thomas Roux'], '8 rue Poyenne', ['entree', 'dessert']],
  ['dasilva', 'les Da Silva', ['Inês Da Silva', 'Marco Da Silva'], '41 cours Portal', ['entree', 'plat', 'dessert']],
  ['garnier', 'les Garnier', ['Hélène Garnier', 'Bruno Garnier'], '12 rue du Couvent', []],
  ['okafor', 'Grace Okafor', ['Grace Okafor'], '5 rue Cornac', ['dessert']],
  ['moreau', 'Élise Moreau', ['Élise Moreau'], '19 rue Sicard', ['entree']],
  ['petit', 'Hugo Petit', ['Hugo Petit'], '2 place Picard', ['plat', 'dessert']],
  ['dubois', 'Camille Dubois', ['Camille Dubois'], '33 rue de Leybardie', ['entree']],
  ['haddad', 'Yasmine Haddad', ['Yasmine Haddad'], '7 rue Delurbe', ['entree', 'plat', 'dessert']],
  ['bernard', 'Louis Bernard', ['Louis Bernard'], '22 quai des Chartrons', ['plat']],
  ['leroy', 'Antoine Leroy', ['Antoine Leroy'], '9 rue Lucien-Faure', ['plat']],
  ['mercier', 'Sophie Mercier', ['Sophie Mercier'], '16 rue Ravez', ['dessert']],
];

const regimes: Record<string, string> = {
  'Claire Martin': 'sans gluten',
  'Karim Benali': 'sans porc',
  'Linh Nguyen': 'végétarienne',
  'Grace Okafor': 'arachides',
  'Hugo Petit': 'végétarien',
  'Yasmine Haddad': 'sans lactose',
  'Louis Bernard': 'fruits à coque',
};

export const foyersDemo: Foyer[] = brut.map(([id, nom, membres, adresse, dispo]) => ({
  id,
  nom,
  adresse,
  veutRecevoir: dispo.length > 0,
  disponibilites: dispo as Foyer['disponibilites'],
  membres: membres.map((prenomNom, i) => ({
    id: `${id}-${i + 1}`,
    prenomNom,
    participe: true,
    regime: regimes[prenomNom],
  })),
}));

export const hotesDemo: AffectationHote[] = [
  { foyerId: 'martin', etape: 'entree' },
  { foyerId: 'nguyenroux', etape: 'entree' },
  { foyerId: 'moreau', etape: 'entree' },
  { foyerId: 'dubois', etape: 'entree' },
  { foyerId: 'benali', etape: 'plat' },
  { foyerId: 'dasilva', etape: 'plat' },
  { foyerId: 'bernard', etape: 'plat' },
  { foyerId: 'haddad', etape: 'plat' },
  { foyerId: 'lefevre', etape: 'dessert' },
  { foyerId: 'okafor', etape: 'dessert' },
  { foyerId: 'petit', etape: 'dessert' },
  { foyerId: 'mercier', etape: 'dessert' },
];

export const demoInput: RepartitionInput = { foyers: foyersDemo, hotes: hotesDemo };
